export default __webpack_public_path__ + "static/media/GSec.ac635ec4.svg";